import React from 'react';
import { useDebugContextState } from '../../../../Context/Debug/DebugContext';
import { DebugButton, DebugButtonProps } from '../../../../Context/Debug/DebugButton';

export const DebugContextButton = (props: DebugButtonProps) => {
    const debugEnabled = useDebugContextState().questionsContext;
    return !debugEnabled ? null : <DebugButton {...props} />;
};

export const DebugGeneralButton = (props: DebugButtonProps) => {
    const debugEnabled = useDebugContextState().questionsHabitation;
    return !debugEnabled ? null : <DebugButton {...props} />;
};
